import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IRouteCache {
  id: number;
  cache_key: string;
  cache_value: string;
}

export class IRouteCacheResponse {
  @Type(() => IRouteCache)
  result: IRouteCache;
}

export class IRouteCacheListResponse extends IPagination {
  @Type(() => IRouteCache)
  results: IRouteCache[];
}

export class IRouteCacheQueryDto extends IQueryPaginationDto {
  cache_key?: string;
  action?: string;
}

export class IRouteCachePostDto {
  cache_key: string;
  cache_value: string;
}

export class IRouteCachePatchDto {
  cache_key?: string;
  cache_value?: string;
}
